<style lang="scss">
.job-form {
  position: relative;

  h2{
    color: #004373;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 28px;
  }

  .error {
    position: relative !important;
    top: unset !important;
    right: unset !important;
  }

  input[type="file"] {
    display: none;
  }

  label {
    color: #5B5D64;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 14px;
  }
  input, textarea{
    border: 1px solid #D9D9D9;
    border-radius: 2px;
    background-color: #FFFFFF;
    &:focus{
      border-color: #004373;
    }
    color: #004373;
  }
  textarea{
    width: 100%;
    height: 138px;
  }

  span.label {
    color: #354052;
    font-size: 11px;
    line-height: 22px;
    display: block;
    margin-bottom: 10px;
  }

  .filename {
    &:after {
      content: "x";
      margin-left: 8px;
      color: black;
      font-weight: 700;
      opacity: 0;
      transition: opacity 0.2s;
    }

    &:hover {
      cursor: pointer;

      &:after {
        opacity: 1;
      }
    }
  }

  .spinner-background {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    .spinner {
      position: absolute;
      z-index: 10;
      top: calc(50% - 30px);
      left: calc(50% - 30px);
      transform: translate(-50%, -50%);
    }
  }

  &.processing {
    form {
      opacity: 0.3;
    }

    .spinner-background {
      display: block;
    }
  }

  .form{
    label{
      color: #5B5D64;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 14px;
    }
  }
  .error{
    color: #F55668;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 14px;
  }
}
</style>

<template>
  <div class="form job-form" :class="{'processing': processing}" id="contactForm">
    <h2 class="text-secondary text-24 mb-40">{{ lang.title }}</h2>
    <ValidationObserver v-slot="obs" ref="observer" tag="form" @submit.prevent="submit()">

      <div class="grid grid-cols-12 mb-16">
        <div class="col-span-12">
          <ValidationProvider ref="name" vid="name" rules="required|min:2" v-slot="props"
                              :name="lang.name" :slim="true">
            <div class="form-group position-relative" :class="props.classes">
              <label for="name">{{ lang.name }}</label>
              <input type="text" id="name" class="form-control block w-full" :placeholder="lang.name"
                     v-model="formData.name"/>
              <span class="error">{{ props.errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
      </div>

      <div class="grid grid-cols-12 mb-16">
        <div class="col-span-12">
          <ValidationProvider ref="email" vid="email" rules="required|email" v-slot="props"
                              :name="lang.email" :slim="true">
            <div class="form-group position-relative" :class="props.classes">
              <label for="email">{{ lang.email }}</label>
              <input type="text" id="email" class="form-control block w-full" :placeholder="lang.email"
              v-model="formData.email"/>
              <span class="error">{{ props.errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
      </div>

      <div class="grid grid-cols-12 mb-16">
        <div class="col-span-12">
          <ValidationProvider ref="phone" vid="phone"
                              :rules="{ required: true, regex:/((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/}"
                              v-slot="props" :name=" lang.telephone" :slim="true">
            <div class="form-group position-relative" :class="props.classes">
              <label for="phone">{{ lang.telephone }}</label>
              <input type="text" id="phone" class="form-control block w-full" :placeholder="lang.telephone"
              v-model="formData.phone"/>
              <span class="error">{{ props.errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
      </div>

      <div class="grid grid-cols-12 mb-16">
        <div class="col-span-12">
          <ValidationProvider ref="message" vid="message" rules="required|min:10" v-slot="props"
                              :name="lang.message" :slim="true">
            <div class="form-group position-relative" :class="props.classes">
              <label for="message">{{ lang.message }}</label>
              <textarea class="form-control flex-grow-1" id="message"
                        :placeholder=" lang.message " v-model="formData.message"/>
              <span class="error error-top">{{ props.errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
      </div>

      <button class="btn btn-primary btn-sm">{{ lang.send }}</button>
    </ValidationObserver>

    <div class="spinner-background">
      <div class="spinner">

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      lang: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        processing: false, //when posting the formData
        submitted: false, //when formData is successfully submitted
        serverError: null, //stores a server error (with optional message)

        formData: {
          name: "",
          email: "",
          phone: "",
          message: "",
          source_url: window.location.href,
        }
      }
    },

    methods: {
      async submit() {
        const isValid = await this.$refs.observer.validate();
        if (isValid) {
          this.processing = true;
          axios
              .post('/contact', this.formData)
              .then((response) => {
                if (response.data.hasOwnProperty('success')) this.done = true;

                document.getElementById('contactForm').innerHTML = "<h3 class='text-primary' "+ this.lang.confirm + "</h3>"

                this.formData.name = "";
                this.formData.email = "";
                this.formData.phone = "";
                this.formData.message = "";
              })
              .catch((error) => {
                this.serverError = error.response.data.message;
              })
              .finally(() => {
                this.processing = false;
              });
        }
      }
    },
  }
</script>
